export const types = {
  set: 'SET_SEARCH_QUERY',
  unset: 'UNSET_SEARCH_QUERY'
} as const

export function setSearchQuery(
  page: string,
  sender: string,
  category: string,
  important_flg: string,
  hot_news_flg: string,
  close_flg: string,
  post: string,
  push: string,
  progress: string
) {
  return {
    type: types.set,
    payload: {
      page,
      sender,
      category,
      important_flg,
      hot_news_flg,
      close_flg,
      post,
      push,
      progress
    }
  }
}
export function unsetSearchQuery() {
  return { type: types.unset }
}
